import { hotRanking } from '@/mocks/home';

const trendMeta: Record<string, { icon: string; color: string }> = {
  up: { icon: 'ri-arrow-up-line', color: 'text-primary-600' },
  down: { icon: 'ri-arrow-down-line', color: 'text-secondary-600' },
  flat: { icon: 'ri-subtract-line', color: 'text-foreground-500' },
};

export default function HotRanking() {
  return (
    <aside className="rounded-lg border border-background-200 bg-background-50" aria-label="热度榜单">
      <div className="flex items-center justify-between border-b-2 border-foreground-950 px-4 py-3.5 md:px-5">
        <div className="flex items-center gap-2">
          <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-fire-line text-base" aria-hidden="true"></i>
          </span>
          <h2 className="font-heading text-lg font-bold text-foreground-950">热度榜</h2>
        </div>
        <span className="flex items-center gap-1.5 text-[11px] text-foreground-500">
          <span className="live-dot block h-1.5 w-1.5 rounded-full bg-primary-500" aria-hidden="true"></span>
          10 分钟刷新
        </span>
      </div>

      <ol className="divide-y divide-background-200">
        {hotRanking.map((item) => {
          const meta = trendMeta[item.trend] ?? trendMeta.flat;
          return (
            <li key={item.rank}>
              <a href="#rank" className="flex cursor-pointer items-start gap-3 px-4 py-3 transition-colors hover:bg-background-100 md:px-5">
                <span
                  className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                    item.rank <= 3
                      ? 'bg-accent-500 text-accent-950'
                      : 'bg-background-200 text-foreground-700'
                  }`}
                >
                  {item.rank}
                </span>
                <div className="min-w-0 flex-1">
                  <h3 className="truncate text-[13px] font-medium text-foreground-900">{item.title}</h3>
                  <div className="mt-2 flex items-center gap-3">
                    <div className="h-1 flex-1 overflow-hidden rounded-full bg-background-200">
                      <div
                        className="h-full rounded-full bg-primary-500"
                        style={{ width: `${item.heat}%` }}
                      ></div>
                    </div>
                    <span className="flex w-14 shrink-0 items-center justify-end gap-0.5 text-[11px]">
                      <i className={`${meta.icon} ${meta.color}`} aria-hidden="true"></i>
                      <span className={meta.color}>{item.change}</span>
                    </span>
                  </div>
                </div>
              </a>
            </li>
          );
        })}
      </ol>

      <div className="border-t border-background-200 p-4 md:px-5">
        <a
          href="#rank"
          className="flex w-full cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-foreground-950 px-4 py-2 text-sm font-medium text-foreground-950 transition-colors hover:bg-foreground-950 hover:text-background-50"
        >
          查看完整榜单
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </a>
      </div>
    </aside>
  );
}